import { type CreateCampaignFormData } from "@/features/whatsapp-campaign";
import { datesToISO } from "@";

export const formatFilterCriteria = (data: CreateCampaignFormData) => {
  return {
    isActive: data.isActive ?? null,
    hasAbandonedCart: data.hasAbandonedCart ?? null,
    specificProjectIds: data.specificProjectIds ?? [],
    excludePhoneNumbers: data.excludePhoneNumbers ?? [],
    specificPhoneNumbers: data.specificPhoneNumbers ?? [],
    donationDateTo: data.donationDateTo
      ? datesToISO(data.donationDateTo)
      : null,
    donationDateFrom: data.donationDateFrom
      ? datesToISO(data.donationDateFrom)
      : null,
    abandonedCartDateTo: data.abandonedCartDateTo
      ? datesToISO(data.abandonedCartDateTo)
      : null,
    abandonedCartDateFrom: data.abandonedCartDateFrom
      ? datesToISO(data.abandonedCartDateFrom)
      : null,
    excludeDonatedFromDate: data.excludeDonatedFromDate
      ? datesToISO(data.excludeDonatedFromDate)
      : null,
    excludeDonatedToDate: data.excludeDonatedToDate
      ? datesToISO(data.excludeDonatedToDate)
      : null,

    minDonationAmount: data.minDonationAmount
      ? Number(data.minDonationAmount)
      : null,
    maxDonationAmount: data.maxDonationAmount
      ? Number(data.maxDonationAmount)
      : null,
    minAbandonedCartAmount: data.minAbandonedCartAmount
      ? Number(data.minAbandonedCartAmount)
      : null,
    maxAbandonedCartAmount: data.maxAbandonedCartAmount
      ? Number(data.maxAbandonedCartAmount)
      : null,
  };
};
